// ChatbotLayout.jsx
import React, { useEffect, useState, useRef } from 'react';
import './cb.css'; 
import { FileIcon, BookIcon, BookPlusIcon, ChartBarDecreasing, CopyIcon, EditIcon, LogOutIcon, SaveIcon, SettingsIcon, TrashIcon,UploadIcon, X } from 'lucide-react';
import LANG from './lang'
import config, { getProfileFromToken } from './config'
import AdminDashboard from './adminpanel';

import { Modal, Spin, message } from 'antd';

let DIM_MIN_W =100;
let DIM_MIN_H=100;
const ChatbotLayout = ({Email, handleLogout, handleSettings}) => {

    const [chats, setChats] = useState(null);
    const [responses, setResponses] = useState(null);
    const [maintainedResponses, setMaintainedResponses] = useState(null)
    const [activeChatId, setActiveChatId] = useState(null);
    const [prompt, setPrompt] = useState('');
    const [editingChatId, setEditingChatId] = useState(null);
    const [newTitle, setNewTitle] = useState('');
    const [answer, setAnswer] = useState(''); 
    const [stage, setStage] = useState(''); 

    const [base64Image, setBase64Image] = useState('');
    
// Stati per la gestione e visualizzazione dei documenti della chat
    const [chatFilesModalVisible, setChatFilesModalVisible] = useState(false);
    const [chatFileList, setChatFileList] = useState([]);
    const [loadingFiles, setLoadingFiles] = useState(false);

    const [pdfVisible, setPdfVisible] = useState(false);
    const [currentPdfUrl, setCurrentPdfUrl] = useState('');
    const [loadingPdf, setLoadingPdf] = useState(false);

    // Recupera la lingua corrente
    const l = LANG(localStorage.getItem('appLanguage'));
const handleOpenChatFiles = async () => {
        if (!activeChatId) return;
        setLoadingFiles(true);
        setChatFilesModalVisible(true);
        
        try {
            const url = `${config.apiUrl}/chat/chatop?action=get&chatid=${activeChatId}`;
            const res = await fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();
            // data[1] contiene la struttura dei file come in AdminDashboard
            setChatFileList(data[1]?.files || []);
        } catch (error) {
            message.error("Errore nel recupero dei file associati");
        } finally {
            setLoadingFiles(false);
        }
    };

    // Stessa funzione apriPdf usata in AdminDashboard
    const apriPdf = async (chatid, nomefile) => {
        setLoadingPdf(true);
        const url = `${config.apiUrl}/download/${chatid}/${nomefile}`;
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Errore nel download");
            const blob = await response.blob();
            
            const isPdf = nomefile.toLowerCase().endsWith('.pdf');
            const mimeType = isPdf ? 'application/pdf' : 'text/plain';
            const blobUrl = URL.createObjectURL(new Blob([blob], { type: mimeType }));
            
            setCurrentPdfUrl(blobUrl);
            setPdfVisible(true);
        } catch (error) {
            message.error("Impossibile caricare il file");
        } finally {
            setLoadingPdf(false);
        }
    };

    // Stessa funzione chiudiPdf usata in AdminDashboard
    const chiudiPdf = () => {
        setPdfVisible(false);
        if (currentPdfUrl.startsWith('blob:')) URL.revokeObjectURL(currentPdfUrl);
        setCurrentPdfUrl('');
    }
    const renderLoading = () => (
        <center>
        <div className="loading-state">
            <div className="spinner"></div> 
                <p>{l.CHAT_LOADING}</p>
        </div>
        </center>
    );
 
    const bottomRef = useRef(null);
    
    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [responses]);

    useEffect(() => {
        try
        {
            fetch(config.apiUrl+"/chat/getactive?current_user="+ localStorage.getItem("email"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json" ,
                },
                body: JSON.stringify()
                }).then((res) => res.json())
            .then((allData) => setChats(allData))
            .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
        } catch (err) {
            //do something
        }
    }, []);
   




     const isValidImageB64 = (b64String) => {
    try {
        // 1. Rimuovi l'header se presente (es. "data:image/png;base64,")
        const pureBase64 = b64String.includes(',') ? b64String.split(',')[1] : b64String;

        // 2. Decodifica la stringa in un array di byte (Uint8Array)
        const binaryString = window.atob(pureBase64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
        }

        // 3. Controlla i primi byte (Magic Numbers)
        const header = bytes.slice(0, 4).reduce((acc, byte) => acc + byte.toString(16).padStart(2, '0'), '');

        const signatures = {
        '89504e47': 'png',
        'ffd8ff': 'jpg',
        '47494638': 'gif',
        '52494646': 'webp' // Nota: webp ha una struttura più complessa, ma inizia con RIFF
        };

        // Verifica se l'header inizia con una delle firme note
        return Object.keys(signatures).some(sig => header.startsWith(sig));
    } catch (e) {
        return false; // Errore nella decodifica, non è un Base64 valido
    }
    };


    const handlequeryResponse =() =>{
        if (activeChatId)
        {
            try
            {
                fetch(config.apiUrl+"/chat/getresponses?current_user="+ localStorage.getItem("email")+"&chatid="+activeChatId, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                    }).then((res) => res.json())
                .then((allData) => { setResponses(allData)
                                     setMaintainedResponses(allData)})
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {

            }
            
        }
        var container = document.getElementById("llll");
        if(container) container.scrollTop = container.scrollHeight;
    };

     useEffect(() => {
        if (activeChatId)
        {
            try
            {
                fetch(config.apiUrl+"/chat/getresponses?current_user="+ localStorage.getItem("email")+"&chatid="+activeChatId, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                    }).then((res) => res.json())
                .then((allData) => { setResponses(allData)
                                     setMaintainedResponses(allData)})
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {
                //do something
            }
        }
       
    }, [activeChatId, answer]);

    const activeChat = chats!==null ? chats.find(c => c.id === activeChatId) : null;

    if (getProfileFromToken() !=="user" && getProfileFromToken() !=="admin" &&   getProfileFromToken() !=="simple")
        return;

    const handleChatChange = (chatId) => {
        setActiveChatId(chatId);
         try
        {
            fetch(config.apiUrl+"/chat/setchatactive?current_user="+ localStorage.getItem("email")+"&chatid="+chatId, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json" ,
                },
            }).then((res) => res.json())
            .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
        } catch (err) {
            //do something
        }
        setEditingChatId(null); 
    };

    const handleStartRename = (chatId, currentTitle, e) => {
        e.stopPropagation(); 
        setEditingChatId(chatId);
        
        setNewTitle(currentTitle);
    };

    const handleSaveRename = (chatId) => {
        if (newTitle.trim()) {
            setChats(prevChats =>
                prevChats.map(chat =>
                    chat.id === chatId ? { ...chat, titolo: newTitle.trim() } : chat
                )
            );
        }
        
        setEditingChatId(null);
        try
        {
            fetch(config.apiUrl+"/chat/setchatname?current_user="+ localStorage.getItem("email")+"&chatid="+chatId+"&newname="+newTitle, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json" ,
                },
            }).then((res) => res.json())
            .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
        } catch (err) {
            //do something
        }

        setNewTitle('');
    };
    
    // --- GESTIONE INTERAZIONI ---

    const handleSendPrompt = async () => {
        
        
        document.getElementById("promptid").disabled = true
        document.getElementById("idfile").value= ""
        setBase64Image("")
        
        if (prompt.trim() === '' || !activeChat) return;
        setStage("query")
        const newPromptText = prompt.trim();
        const actl =  localStorage.getItem('appLanguage');
        const payload = {
            query :  newPromptText,
            user: localStorage.getItem("email"),
            images : ((isValidImageB64(base64Image)) ? base64Image:""),
            model:"",
            chatid : activeChatId,
            lang : actl,
            k_context :  3
        };
        console.log(payload)
        
        try
        {
            await fetch(config.apiUrl+"/query", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json" ,
                    "Authorization": "Bearer "+localStorage.getItem("token")
                },
                body: JSON.stringify(payload)
                }).then((res) => res.json())
            .then((allData) => {setAnswer(allData.answer)})
                            
            .catch((error) => console.error("Errore nel fetch dei dettagli:", error) );
            
        } catch (err) {
            //do something
        }
        
        handlequeryResponse();
        document.getElementById("promptid").disabled = false
        setPrompt('');
        setStage("")
    };

    
    
    
    
    
    const handleFileChange = (event) => {
        const file = event.target.files[0];
    
        if (file) {
        const reader = new FileReader();
        
        reader.onloadend = () => {
            // Il risultato contiene: "data:image/jpeg;base64,/9j/4AAQ..."
            // Spesso ai modelli AI serve solo la parte dopo la virgola
            const fullBase64 = reader.result;
            const cleanBase64 = fullBase64.split(',')[1]; 
            
            setBase64Image(cleanBase64);
            
        };
    
        reader.readAsDataURL(file); // Converte l'immagine in stringa Base64
        /* if (isValidImageB64(base64Image)){

            console.log(base64Image)
            handleSendImgPrompt();
        } */
    }
  };
    const handleSendImgPrompt = async () => {
        
        document.getElementById("promptid").disabled = true

        setStage("query")
        const newPromptText = prompt.trim();
        const actl =  localStorage.getItem('appLanguage');
        const payload = {
            query :  newPromptText,
            user: localStorage.getItem("email"),
            images :base64Image ,
            model:"llava",
            chatid : activeChatId,
            lang : actl,
            k_context :  3
        };
        console.log(payload)
        
        try
        {
            await fetch(config.apiUrl+"/query", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json" ,
                    "Authorization": "Bearer "+localStorage.getItem("token")
                },
                body: JSON.stringify(payload)
                }).then((res) => res.json())
            .then((allData) => {setAnswer(allData.answer)})
                            
            .catch((error) => console.error("Errore nel fetch dei dettagli:", error) );
            
        } catch (err) {
            //do something
        }
        
        handlequeryResponse();
        document.getElementById("promptid").disabled = false
        setPrompt('');
        setStage("")
    };

    
    const handleResponseAction = (id, action) => {
        const responseToActOn = responses.resp.find(res => res.id === id);

        if (!responseToActOn) return;

        if (action === 'keep') {
             try
            {
                fetch(config.apiUrl+"/chat/chatrespop?action=keep&current_user="+ localStorage.getItem("email")+"&resid="+id, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                }).then((res) =>    {   res.json();
                                        handlequeryResponse() 
                                    }
                        )         
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {
                 handlequeryResponse() 
            }
        } else if (action === 'delete') {
            try
            {
                fetch(config.apiUrl+"/chat/chatrespop?action=delete&current_user="+ localStorage.getItem("email")+"&resid="+id, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                }).then((res) => {res.json()
                    handlequeryResponse() 
                    })
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {
                handlequeryResponse() 
            }
        } else if (action === 'copy') {
            navigator.clipboard.writeText(responseToActOn.response)
                .then(() => alert(l.CHAT_MSG_COPY_SUCCESS))
                .catch(err => console.error('Errore nella copia: ', err));
        }
    };

    const handleMantenutaAction = (id, action) => {
        const responseToActOn = responses.maresp.find(res => res.id === id);
        
        if (!responseToActOn) return;
         if (action === 'delete') {
            try
            {
                fetch(config.apiUrl+"/chat/chatrespop?action=deletemantenuta&current_user="+ localStorage.getItem("email")+"&resid="+id, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                }).then((res) => {res.json()
                    handlequeryResponse() 
                    })
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {
                handlequeryResponse() 
            }
        } else if (action === 'copy') {
            navigator.clipboard.writeText(responseToActOn.response)
                .then(() => alert(l.CHAT_MSG_COPY_SUCCESS))
                .catch(err => console.error('Errore nella copia: ', err));
        }
    };

    return (
        <div className="app-container">
            {/* 1. Input Prompt (Header) */}
            <header className="header-input">
                
                {l.CHAT_PLACEHOLDER_INPUT} 
                <textarea
                    id="promptid"
                    type="text"
                    className="prompt-input"
                    placeholder={activeChat ? "...." : ""}
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') handleSendPrompt();
                    }}
                    disabled={!activeChatId}
                    rows="3"
                >
                </textarea>
                <button className="send-button" onClick={handleSendPrompt} disabled={!activeChatId}>
                    {l.CHAT_BTN_SEND}
                </button>
                <label className="file-input-wrapper">
                    <UploadIcon size={18} />
                    {l.CHAT_CONFIG_FILE_UPLOAD_BTN}
                    <input 
                        type="file" 
                        onChange={handleFileChange} 
                        accept=".png, .jpg" 
                        id="idfile"
                        
                    />
                </label>
                
            </header>

            {/* 2. Lista delle Chats (Sinistra) */}
            <aside className="headerc-container colonna-laterale">
                <div className="user-info-bar">
                      <table>
                        <tbody>
                            <tr>
                                <td><span className="logged-in-email">??<b>{Email}</b></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {stage === "query" && renderLoading()}
                </div>
            </aside>
            <aside className="cronologia-container colonna-laterale">
                   <h3>
                    <BookIcon/>{l.CHAT_TITLE} 
                    </h3>
                                    {(activeChatId && 
                        <button 
                            className="clear-button" 
                            onClick={handleOpenChatFiles} 
                            disabled={!activeChatId}
                            style={{ marginTop: '10px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                        >
                    <FileIcon size={16} /> Documenti Agente
                </button>)}
                <div className="cronologia-lista">
                    
                    {chats!==null && chats.map(chat => (
                        <div
                            key={chat.id}
                            className={`cronologia-item ${chat.id === activeChatId ? 'active-chat' : ''}`}
                            onClick={() => handleChatChange(chat.id)}
                            title={chat.titolo}
                        >
                            {editingChatId === chat.id ? (
                                <div className="chat-edit-container">
                                    <input
                                        type="text"
                                        value={newTitle}
                                        onChange={(e) => setNewTitle(e.target.value)}
                                        onClick={(e) => e.stopPropagation()}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') handleSaveRename(chat.id);
                                        }}
                                        style={{ flexGrow: 1, padding: '3px', border: '1px solid #007bff' }}
                                    />
                                    <button onClick={() => handleSaveRename(chat.id)} title={l.CHAT_BTN_SAVE}>
                                        ✔
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <span style={{ flexGrow: 1 }}>{chat.titolo}</span>
                                    <div className="chat-actions">
                                        <button 
                                            onClick={(e) => handleStartRename(chat.id, chat.titolo, e)} 
                                            title={l.CHAT_BTN_RENAME}
                                            className="action-btn"
                                            style={{marginRight: '5px'}}
                                            >
                                            <EditIcon/>
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    ))}
                    {chats === null  && <p style={{ color: '#888', fontSize: '0.9em' }}>{l.CHAT_PLACEHOLDER_EMPTY_HISTORY}</p>}
                </div>
            </aside>
            <aside className="headerm-container colonna-laterale">
                <div className="user-info-bar" >
                    <table>
                        <tbody>
                        <tr>
                            <td><img alt="log" width="50%" src="aimoxicona.png"/></td>
                            <td><button className="clear-button" onClick={handleLogout} style={{ border: '0px'}}>
                        <LogOutIcon/> 
                    </button></td>
                    {(getProfileFromToken() ==="user" || getProfileFromToken() ==="admin" ) &&
                            <td>
                                
                                <button className="clear-button" onClick={handleSettings} style={{ border: '0px'}}>
                        <SettingsIcon/> 
                    </button></td>
                            }
                        </tr>
                        </tbody>
                    </table>
                </div>
            </aside>
            
            {/* 3. Contenuto Principale (Centro) - Risposte Recenti */}
            <main className="contenuto-principale">
                <div className="filigrana-logo" title="AI MOX">
                    <img alt="log" width="100%" src="aimoxicona.png"/>
                </div>
                <h2>{l.CHAT_TITLE_RECENT_RESPONSES} - {activeChat?.titolo || l.CHAT_SELECT_CHAT}
                </h2>
                <ul className="risposte-lista" >
                    {responses !== null && responses.resp.map(res => (
                        <li key={res.id} className="risposta-item">
                            <p className="user-prompt">{res.prompt}</p>
                                {isValidImageB64(res.imgrq) ? (
                                
                                        <img 
                                        src={`data:image/jpeg;base64,${res.imgrq}`} 
                                        alt="Generated" 
                                        style={{ maxWidth: '100%', height: 'auto' }} 
                                        />
                                    ) : (
                                    <p> </p>

                                    )}
                            <div className="response-content">
                               <p>{res.response}</p>					 
                                {res.imgres && Array.isArray(res.imgres) && res.imgres.length > 0 ? (
                                    <div style={{ 
                                        display: 'flex', 
                                        flexWrap: 'wrap', 
                                        gap: '10px', 
                                        marginTop: '10px',
                                        justifyContent: 'center' 
                                    }}>
                                        {res.imgres.map((imgB64, index) => (
                                            <img 
                                                key={`${res.id}-${index}`}
                                                src={`data:image/png;base64,${imgB64}`} 
                                                alt={`Pittogramma ${index}`} 
                                                style={{ 
                                                    width: Math.max(DIM_MIN_W, 900/res.imgres.length) +"px", 
                                                    height: Math.max(DIM_MIN_H,600/res.imgres.length) +"px", 
                                                    objectFit: 'contain',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '8px',
                                                    padding: '5px',
                                                    backgroundColor: '#fff'
                                                }} 
                                                // Gestione errore se il b64 � corrotto
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    null

                                )}

                            </div>
                            <div className="response-actions">
                                <button className="delete-btn" onClick={() => handleResponseAction(res.id, 'delete')}>
                                    <TrashIcon/> {l.CHAT_RESPONSE_DELETE}
                                </button>
                                <button className="copy-btn" onClick={() => handleResponseAction(res.id, 'copy')}>
                                    <CopyIcon/> {l.CHAT_RESPONSE_COPY}
                                </button>
                                <button className="keep-btn" onClick={() => handleResponseAction(res.id, 'keep')}>
                                    <SaveIcon/> {l.CHAT_RESPONSE_KEEP}
                                </button>
                            </div>
                        </li>
                    ))}
                    <div ref={bottomRef} />
                </ul>
                <div id="llll"> </div>
            </main>

            {/* 4. Risposte Mantenute (Destra) */}
            <aside className="mantenute-container colonna-laterale">
                <h3>{l.CHAT_TITLE_MAINTAINED_RESPONSES}</h3>
                <div className="mantenute-lista">
                                        
                    {maintainedResponses !== null &&  maintainedResponses.maresp !== null && maintainedResponses.maresp.map(item => (
                        <div key={item.id} className="mantenuta-item">
                            <p style={{ fontWeight: 'bold', margin: '0 0 5px 0', borderBottom: '1px dashed #ccc', paddingBottom: '3px' }}>
                                {item.prompt}
                                {isValidImageB64(item.imgrq) ? (
                                
                                        <img 
                                        src={`data:image/jpeg;base64,${item.imgrq}`} 
                                        alt="Generated" 
                                        style={{ maxWidth: '100%', height: 'auto' }} 
                                        />
                                    ) : (
                                    <p> </p>

                                    )}
                            </p>
                            
                            <p style={{ margin: '0 0 10px 0', fontSize: '0.9em' }}>
                                {item.response}
                            </p>
                            <div className="response-content">
                                
                                {item.imgres && Array.isArray(item.imgres) && item.imgres.length > 0 ? (
                                    <div style={{ 
                                        display: 'flex', 
                                        flexWrap: 'wrap', 
                                        gap: '10px', 
                                        marginTop: '10px',
                                        justifyContent: 'center' 
                                    }}>
                                        {item.imgres.map((imgB64, index) => (
                                            <img 
                                                key={`${item.id}-${index}`}
                                                src={`data:image/png;base64,${imgB64}`} 
                                                alt={`Pittogramma ${index}`} 
                                                style={{ 
                                                    width: DIM_MIN_W +"px", 
                                                    height: DIM_MIN_H +"px",  
                                                    objectFit: 'contain',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '8px',
                                                    padding: '5px',
                                                    backgroundColor: '#fff'
                                                }} 
                                                // Gestione errore se il b64 � corrotto
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    null

                                )}
                                  

                            </div>
                            <div className="response-actions">
                            <button
                                className="delete-btn"
                                onClick={() => handleMantenutaAction(item.id, 'delete')}
                            >
                                <TrashIcon/> 
                            </button>
                            <button className="copy-btn" onClick={() => handleMantenutaAction(item.id, 'copy')}>
                                <CopyIcon/> 
                            </button>
                            </div>
                        </div>
                    ))}
                </div>
            </aside>
            {/* 1. Modale con l'elenco dei file della chat */}
<Modal
    title={`Documenti associati a: ${activeChat?.titolo || ''}`}
    open={chatFilesModalVisible}
    onCancel={() => setChatFilesModalVisible(false)}
    footer={null}
    destroyOnClose
>
    {loadingFiles ? (
        <center><Spin style={{ margin: '20px 0' }} /></center>
    ) : chatFileList.length === 0 ? (
        <p style={{ padding: '10px 0' }}>Nessun documento associato a questa chat.</p>
    ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
            {chatFileList.map((fileName, index) => (
                <li key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #eee' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FileIcon size={16} /> {fileName}
                    </span>
                    <button 
                        className="smalls save-button"
                        onClick={() => apriPdf(activeChatId, fileName)}
                    >
                        Visualizza
                    </button>
                </li>
            ))}
        </ul>
    )}
</Modal>

    {/* 2. Modale Visualizzatore File (Stesso codice di AdminDashboard) */}
    <Modal
        title="Visualizzazione Documento"
        open={pdfVisible}
        onCancel={chiudiPdf}
        footer={null}
        width="85%"
        style={{ top: 20 }}
        styles={{ body: { height: '85vh', padding: 0, overflow: 'hidden' } }}
        closeIcon={<X className='poi-back-button' style={{ fontSize: 20 }} />}
        destroyOnClose
    >
        {currentPdfUrl && (
            <iframe 
                src={currentPdfUrl.toLowerCase().endsWith('.pdf') ? `${currentPdfUrl}#view=FitH` : currentPdfUrl} 
                width="100%" 
                height="100%" 
                style={{ border: 'none', marginTop: 20 }} 
                title="File Viewer" 
            />
        )}
    </Modal>
        </div>
    );


    // Recupera la lista dei file per la chat attiva e apre la modale elenco
    ;
};

export default ChatbotLayout;